import React, { useEffect, useRef, useState } from "react";
import "./Histoire.css";

import rightImg from "../../../images/Histoire/1.jpg";
import leftImg from "../../../images/Histoire/2.jpg";
import right2 from "../../../images/Histoire/3.jpg";
import fondateur from "../../../images/Histoire/fondateur.png";

export default function Histoire() {
  const sectionRef = useRef(null);
  const mainRef = useRef(null);
  const imageRefs = useRef([]);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const sectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    sectionObserver.observe(section);

    return () => sectionObserver.disconnect();
  }, []);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const elements = section.querySelectorAll(".reveal-on-scroll");

    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
          }
        });
      },
      {
        threshold: 0.16,
        rootMargin: "0px 0px -8% 0px",
      }
    );

    elements.forEach((el) => revealObserver.observe(el));

    return () => revealObserver.disconnect();
  }, []);

  useEffect(() => {
    let ticking = false;

    const updateParallax = () => {
      const section = sectionRef.current;
      if (!section) {
        ticking = false;
        return;
      }

      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const progress = Math.max(
        -1,
        Math.min(1, (windowHeight - rect.top) / (windowHeight + rect.height))
      );

      if (mainRef.current) {
        mainRef.current.style.setProperty("--parallaxY", `${progress * -18}px`);
      }

      imageRefs.current.forEach((img, index) => {
        if (!img || img === mainRef.current) return;
        const direction = index % 2 === 0 ? 1 : -1;
        img.style.setProperty("--parallaxY", `${progress * 16 * direction}px`);
      });

      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    };

    updateParallax();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const setImageRef = (el) => {
    if (el && !imageRefs.current.includes(el)) {
      imageRefs.current.push(el);
    }
  };

  return (
    <section
      ref={sectionRef}
      className={`Histoire ${isVisible ? "show" : ""}`}
    >
      <div className="Histoire_bg"></div>

      <div className="Histoire_container">
        <span className="Histoire_dot"></span>

        <div className="Histoire_grid">
          <div className="Histoire_center">
            <div className="Histoire_card">
              <span className="Histoire_kicker reveal-on-scroll reveal-soft delay-1">
                Notre histoire
              </span>

              <h2 className="reveal-on-scroll reveal-soft delay-2">
                Hommage au père
                <br />
                des fondateurs d&apos;Elements
              </h2>

              <p className="reveal-on-scroll reveal-soft delay-1">
                L&apos;histoire d&apos;<strong>ELEMENTS</strong> est avant tout celle
                d&apos;un héritage précieux et d&apos;une passion partagée. À
                l&apos;origine de cette aventure, il y avait un homme : le père de
                Mohamed et Hechem Trabelsi, un menuisier talentueux et dévoué,
                dont l&apos;atelier était un véritable sanctuaire de bois et de
                créativité.
              </p>

              <p className="reveal-on-scroll reveal-soft delay-2">
                C&apos;est là, au milieu des copeaux de bois et du parfum des
                essences naturelles, que les deux frères ont grandi. Dès leur
                plus jeune âge, ils ont absorbé le savoir-faire artisanal de
                leur père, qui leur a transmis bien plus qu&apos;un métier, mais un
                amour indéfectible pour le travail bien fait et l&apos;art de
                transformer la matière brute en chef-d&apos;œuvre.
              </p>

              <p className="reveal-on-scroll reveal-soft delay-3">
                La disparition soudaine de leur père fut un choc. Cependant, au
                lieu de céder à la douleur, Mohamed et Hechem ont trouvé dans
                cette épreuve une source de motivation inébranlable. Déterminés
                à honorer sa mémoire et à perpétuer la passion qu&apos;il leur avait
                léguée, ils se sont lancés avec ardeur dans leurs études,
                portés par le désir de réaliser le rêve de leur père :
                propulser l&apos;atelier familial vers un avenir marqué par
                l&apos;excellence et l&apos;innovation.
              </p>

  <figure className="Histoire_mainImage">
                  <div
                    ref={setImageRef}
                    className="Histoire_motion reveal-on-scroll reveal-image delay-2"
                  >
                    <img src={fondateur} alt="Fondateur" />
                  </div>
                </figure>

              <p className="reveal-on-scroll reveal-soft delay-1">
                Aujourd&apos;hui, chaque projet mené par <strong>ELEMENTS</strong>,
                chaque matériau sélectionné avec soin, et chaque design qui voit
                le jour, est imprégné de la passion transmise par leur père.
                C&apos;est un hommage silencieux mais puissant à cet artisan dont
                l&apos;esprit continue de guider leurs mains et d&apos;alimenter leur
                vision.
              </p>

              <p className="reveal-on-scroll reveal-soft delay-2">
                <strong>ELEMENTS</strong> est bien plus qu&apos;une marque, c&apos;est la
                promesse que la passion et le savoir-faire familial se
                transmettent de génération en génération, avec pour seul but de
                créer des œuvres qui inspirent, tout en rendant hommage à ceux
                qui les ont initiées.
              </p>


              <p className="Texte_centrer reveal-on-scroll reveal-soft delay-2">
                Fondée avec une passion profonde pour l&apos;architecture et le
                design, <strong>ELEMENTS</strong> a su se démarquer dans
                l&apos;univers de l&apos;ameublement sur mesure en créant des
                espaces de vie uniques et personnalisés. Dès ses origines,
                notre entreprise a été guidée par une mission claire :
                redéfinir l&apos;expérience d&apos;aménagement intérieur en
                offrant à nos clients des solutions adaptées à leurs besoins,
                tout en mettant en valeur l&apos;authenticité et l&apos;élégance
                de chaque création.
              </p>

              <div className="Histoire_editorialRow">
                <div className="Histoire_editorialText reveal-on-scroll reveal-soft">
                  <p className="Texte_left">
                    Chez <strong>ELEMENTS</strong>, notre vision repose sur un
                    principe fondamental : offrir à chaque client une expérience
                    unique, où la personnalisation est au cœur de nos
                    créations. Nous croyons que chaque espace de vie mérite
                    d&apos;être le reflet des goûts, des besoins et du mode de vie
                    de ceux qui l&apos;habitent. C&apos;est pourquoi, depuis nos
                    débuts, nous avons fait de l&apos;ultra-personnalisation le
                    pilier de notre approche.
                  </p>
                </div>

                <figure className="Histoire_editorialImage">
                  <div
                    ref={setImageRef}
                    className="Histoire_motion reveal-on-scroll reveal-image delay-2"
                  >
                    <img src={rightImg} alt="Entreprise Elements" />
                  </div>
                </figure>
              </div>

              <div className="Histoire_editorialRow reverse">
                <div className="Histoire_editorialText reveal-on-scroll reveal-soft">
                  <p className="Texte_left">
                    La qualité, pour nous, est bien plus qu'une exigence : c&apos;est une promesse. 
Chaque détail, chaque matériau, chaque finition est soigneusement sélectionné 
pour garantir des cuisines d&apos;exception, faites pour durer et sublimer vos 
intérieurs. Notre engagement envers l&apos;excellence se reflète dans notre choix de 
partenaires et dans le savoir-faire artisanal que nous avons su conserver, tout 
en intégrant les dernières technologies.
                  </p>
                </div>

                <figure className="Histoire_editorialImage hide-mobile">
                  <div
                    ref={setImageRef}
                    className="Histoire_motion reveal-on-scroll reveal-image delay-2"
                  >
                    <img src={leftImg} alt="Entreprise Elements" />
                  </div>
                </figure>
              </div>

              <div className="Histoire_editorialRow">
                <div className="Histoire_editorialText reveal-on-scroll reveal-soft">
                  <p className="Texte_left">
                    L&apos;innovation est au centre de notre ADN. Nous repoussons
                    constamment les limites du design et de la fonctionnalité
                    pour proposer des solutions avant-gardistes, adaptées aux
                    modes de vie modernes. Que ce soit à travers
                    l&apos;intégration des technologies intelligentes ou par le
                    choix de matériaux durables et innovants, nous cherchons
                    sans cesse à réinventer l&apos;expérience de l&apos;agencement
                    intérieur et des cuisines.
                  </p>
                </div>

                <figure className="Histoire_editorialImage">
                  <div
                    ref={setImageRef}
                    className="Histoire_motion reveal-on-scroll reveal-image delay-2"
                  >
                    <img src={right2} alt="Entreprise Elements" />
                  </div>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}